var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueBackgroundDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "url(#paint0_linear_2547_5725)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2547_5725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3965 13.2441L14.5742 9.06641L18.7519 13.2441C21.0593 15.5514 21.0593 19.2923 18.7519 21.5996C16.4447 23.9069 12.7038 23.9069 10.3965 21.5996C8.08919 19.2923 8.08919 15.5514 10.3965 13.2441Z",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.999 10.3307C19.999 10.7728 20.1746 11.1967 20.4872 11.5092C20.7997 11.8218 21.2237 11.9974 21.6657 11.9974C22.1077 11.9974 22.5316 11.8218 22.8442 11.5092C23.1568 11.1967 23.3324 10.7728 23.3324 10.3307C23.3324 9.8887 23.1568 9.46478 22.8442 9.15222C22.5316 8.83966 22.1077 8.66406 21.6657 8.66406C21.2237 8.66406 20.7997 8.83966 20.4872 9.15222C20.1746 9.46478 19.999 9.8887 19.999 10.3307Z",
    stroke: "white",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2547_5725",
    x1: 32,
    y1: 32,
    x2: 0,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#277AF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27C6F6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2547_5725"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueBackgroundDrop);
export default __webpack_public_path__ + "static/media/blue-background-drop.6d2465913089041652ebf8ce1408ce07.svg";
export { ForwardRef as ReactComponent };